const IconDiamond = ({ color }) => {
  return (
    <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14.0003 23.3337L5.34669 12.5166C5.01418 12.101 4.84792 11.8931 4.80325 11.6427C4.75858 11.3922 4.84274 11.1397 5.01106 10.6348L6.08863 7.40208C6.52864 6.08204 6.74865 5.42202 7.27242 5.04451C7.7962 4.66699 8.49192 4.66699 9.88336 4.66699H18.1173C19.5087 4.66699 20.2045 4.66699 20.7282 5.04451C21.252 5.42202 21.472 6.08204 21.912 7.40208L22.9896 10.6348C23.1579 11.1397 23.2421 11.3922 23.1974 11.6427C23.1527 11.8931 22.9865 12.101 22.654 12.5166L14.0003 23.3337ZM14.0003 23.3337L18.0837 10.5003M14.0003 23.3337L9.91699 10.5003M22.7503 11.667L18.0837 10.5003M18.0837 10.5003L16.3337 5.83366M18.0837 10.5003H9.91699M11.667 5.83366L9.91699 10.5003M9.91699 10.5003L5.25033 11.667"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  )
}

export default IconDiamond
